import React from "react";
import { Route } from "react-router-dom";
import { PaddedRouteArea } from "shared/Layout";
import { ProtectedRoute } from "components/authorization/ProtectedRoute";
import { RbacPolicies } from "components/authorization/RbacPolicies";
import { UserDelete } from "areas/users/userDetails/UserDelete";
import { AddUserFormPage } from "./AddUserFormPage";
import { UserRoutesMap } from "./UserRoutesMap";
import { UsersPage } from "./UsersPage";
import { UserAuditDetails } from "./userDetails/UserAuditDetails";
import { UserDetails } from "./userDetails/UserDetails";
import { UserDetailLayout } from "./userDetails/UserDetailsLayout";
import { UserProducts } from "./userDetails/UserProducts";

export const userRoutes = () => {
  return (
    <Route path={UserRoutesMap.root} element={<ProtectedRoute policies={RbacPolicies.Users.Read} />}>
      <Route index element={<ProtectedRoute policies={RbacPolicies.Users.Read} element={<UsersPage />} />} />
      <Route element={<PaddedRouteArea />}>
        <Route
          path={UserRoutesMap.detail(":userId").root}
          element={<ProtectedRoute policies={RbacPolicies.Users.Read} element={<UserDetailLayout />} />}
        >
          <Route index element={<ProtectedRoute policies={RbacPolicies.Users.Read} element={<UserDetails />} />} />
          <Route
            path={UserRoutesMap.detail(":userId").products}
            element={<ProtectedRoute policies={RbacPolicies.Users.Read} element={<UserProducts />} />}
          />
          <Route
            path={UserRoutesMap.detail(":userId").audit}
            element={<ProtectedRoute policies={RbacPolicies.Users.Read} element={<UserAuditDetails />} />}
          />
          <Route
            path={UserRoutesMap.detail(":userId").delete}
            element={<ProtectedRoute policies={RbacPolicies.Users.ReadWrite} element={<UserDelete />} />} //TODO: User delete policy
          />
        </Route>
        <Route
          path={UserRoutesMap.add}
          element={<ProtectedRoute policies={RbacPolicies.Users.ReadWrite} element={<AddUserFormPage />} />}
        />
      </Route>
    </Route>
  );
};
